<template>
  <div class="wrap">
    <div class="my_page">
      <div class="key_visual addImg mypage">
        <!-- <div class="container">
          <p>마이페이지</p>
        </div> -->
      </div>

      <div class="my_page_content custom">
        <div class="container">
          <div class="mypage_tab">
            <ul>
              <li class="on">프로필</li>
              <li @click="moveToUrl('/order_list')">구매내역</li>
            </ul>
          </div>
          <div class="form_area">
            <form>
              <div class="form_section">
                <div class="group_itle">
                  <h3>기본 정보</h3>
                  <!-- <router-link to="/withdrawal">회원탈퇴하기</router-link> -->
                  <!-- <a href="/withdrawal">회원탈퇴하기</a> -->
                </div>
                <div class="table_group">
                  <table class="table_style_1">
                    <tbody>
                      <colgroup>
                        <col width="140px" />
                        <col width="*" />
                      </colgroup>
                      <tr>
                        <th>아이디</th>
                        <!-- <td> -->
                        <td class="required">
                          <input
                            id="userid"
                            type="text"
                            :value="userData.userid"
                            name="userid"
                            readonly
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>이름</th>
                        <!-- <td> -->
                        <td class="required">
                          <input
                            id="username"
                            type="text"
                            :value="userData.username"
                            name="username"
                            readonly
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>휴대폰 번호</th>
                        <td>
                          <input
                            id="phone"
                            type="phone"
                            :value="formattingNum"
                            name="phone"
                            readonly
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>이메일 주소</th>
                        <td>
                          <input
                            id="email"
                            type="email"
                            :value="userData.email"
                            name="email"
                            readonly
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>마케팅 정보 수신 확인</th>
                        <td class="none_bg">
                          <div class="marketing">
                            <div v-if="userData.recv_sms === 'Y'">
                              <input
                                id="marketing_sms"
                                type="checkbox"
                                checked
                                disabled
                              />
                              <label for="marketing_sms"></label>
                              <label for="marketing_sms" class="marketing_sms"
                                >문자메시지 수신</label
                              >
                            </div>
                            <div v-else>
                              <input
                                id="marketing_sms"
                                type="checkbox"
                                disabled
                              />
                              <label for="marketing_sms"></label>
                              <label for="marketing_sms" class="marketing_sms"
                                >문자메시지 수신</label
                              >
                            </div>
                            <div v-if="userData.recv_email === 'Y'">
                              <input
                                id="marketing_email"
                                type="checkbox"
                                checked
                                disabled
                              />
                              <label for="marketing_email"></label>
                              <label
                                for="marketing_email"
                                class="marketing_email"
                                >이메일 수신</label
                              >
                            </div>
                            <div v-else>
                              <input
                                id="marketing_email"
                                type="checkbox"
                                disabled
                              />
                              <label for="marketing_email"></label>
                              <label
                                for="marketing_email"
                                class="marketing_email"
                                >이메일 수신</label
                              >
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-if="userData.group === '단체'" class="form_section">
                <div class="group_itle">
                  <h3>소속 정보</h3>
                </div>
                <div class="table_group">
                  <table class="table_style_1">
                    <tbody>
                      <tr>
                        <th>소속</th>
                        <!-- <td> -->
                        <td class="required">
                          <input
                            id="organization"
                            type="text"
                            :value="userBelonging.organization"
                            name="organization"
                            readonly
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>학부 / 학과</th>
                        <!-- <td> -->
                        <td class="required">
                          <span id="colg">{{ userBelonging.colg }}</span>
                          <span id="dept">{{ userBelonging.dept }}</span>
                          <span id="majr">{{ userBelonging.majr }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th>학번</th>
                        <!-- <td> -->
                        <td class="required">
                          <input
                            id="clno"
                            type="text"
                            :value="userBelonging.clno"
                            name="clno"
                            readonly
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="btn_area">
                <!-- <a href="/withdrawal" class="btn_basic">본인인증 하기</a>
                <a href="/withdrawal" class="btn_basic done">본인인증 완료</a> -->
                <a href="/mypage_password_change" class="btn_basic"
                  >비밀번호 변경</a
                >
                <a href="/mypage_pwd" class="btn_orange">프로필 수정</a>
                <a href="/withdrawal" class="btn_basic">회원탈퇴</a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div>
      <ModalAlert
        :alertMsg="errMsg"
        :isOpen="errStatus"
        :trigger="errTrigger"
        @update:isOpen="updateStatus"
      />
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'

// import { loadMypage, mypageValidity} from '../api/mypage';
import { loadMypage } from '../api/mypage'
import ModalAlert from '../components/ModalAlert.vue'

export default {
  name: 'MypageView',
  components: {
    ModalAlert,
  },
  setup() {
    const router = useRouter()

    const errMsg = ref('')
    const errStatus = ref(false)
    const errTrigger = ref('')

    const userData = ref([])
    const userBelonging = ref([])

    const phoneNum = ref('')
    const updateStatus = () => {
      errStatus.value = false
    }
    const getData = async () => {
      const response = await loadMypage()
      // console.log(response)
      if (response.status_code) {
        if (response.status_code === 200) {
          userData.value = response.content
          userBelonging.value = response.content.belonging
          phoneNum.value = userData.value.phone
        }
      } else if (response === 401) {
        errStatus.value = true
        errTrigger.value = 'onTrigger'
        errMsg.value = '비정상적인 접근입니다.'
      } else {
        console.log('err')
      }
      // if (response.status_code === 200) {
      //   userData.value = response.content
      //   userBelonging.value = response.content.belonging
      // }
      // // else if (response === 401) {
      // //   console.log('errrrrr')
      // //   errStatus.value = true
      // //   errTrigger.value = 'onTrigger'
      // //   errMsg.value = '비정상적인 접근입니다.'
      // // }
      // else {
      // console.log('err')
      // }
    }
    const formattingNum = computed(() => {
      let settingNum = phoneNum.value
      if (settingNum.length === 11) {
        settingNum = settingNum.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
      }
      return settingNum
    })

    const moveToUrl = (url) => {
      // window.location.href = url
      router.push({ path: url })
    }
    onMounted(() => {
      getData()
    })
    return {
      errMsg,
      errStatus,
      errTrigger,
      updateStatus,

      userData,

      formattingNum,

      userBelonging,
      getData,
      moveToUrl,
    }
  },
}
</script>
